import React, {Component} from 'react';
import style from '../css/matchdayMoreBets.css';
import {connect} from 'react-redux';
import Accordion from '../containers/accordion'
import WinDrawWin from '../components/winDrawWin';
import CorrectScore from '../components/correctScore';
import TotalGoals from '../components/totalGoals';
import UnderOver from '../components/underOver';
import BothTeamsScore from '../components/bothTeamsScore';
import Handicap from '../components/handicap';
import {
    ALL_MATCHDAY_MARKETS,
    BOTH_TEAMS_SCORE,
    CORRECT_SCORE,
    HANDICAP,
    TOTAL_GOALS,
    UNDER_OVER,
    WIN_DRAW_WIN
} from '../constants/marketTypes';
import {getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
import {setSelectedMatchdayEventId} from "../../../../../actions/eventsActions";
import {isMatchdayNMB} from '../helpers/matchdayHelper';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        selectedMatchdayEventId: state.vpp.matchday.selectedMatchdayEventId,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        channelEventBets: state.vpp.channelEventBets
    };
};

class MatchdayMoreBets extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();
        this.fadeInContent = true;
        this.previousSelectedMatchdayEventId = undefined;
        this.containerRef = React.createRef();
        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            games: storeData.vpp.games,
            selectedMatchdayEventId: storeData.vpp.matchday.selectedMatchdayEventId,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        if (this.state.selectedMatchdayEventId !== storeData.vpp.matchday.selectedMatchdayEventId) {
            this.fadeInContent = true;
        }
        if (nextProps && storeData) {
            this.setState({
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                games: storeData.games,
                selectedMatchdayEventId: storeData.vpp.matchday.selectedMatchdayEventId,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                channelEventBets: storeData.vpp.channelEventBets
            });
        }
    }

    componentDidMount() {
        this.containerRef.current.scrollIntoView({behavior: 'instant', block: 'start'});
        this._handleFadeEffect();
        this.props.updateCallback();
    }

    componentDidUpdate() {
        this._handleFadeEffect();
    }

    _handleFadeEffect() {
        if (this.fadeInContent) {
            setTimeout(() => {
                this.fadeInContent = false;
                this.forceUpdate();
            }, 500);
        }
    }

    _closeMoreBetsScreen() {
        this.props.store.dispatch(setSelectedMatchdayEventId(undefined, this.props.store));
    }

    _generateMarketUI(marketCode, selectedMatchdayEvent, key) {
        let store = this.props.store;

        let eventMarkets = selectedMatchdayEvent ? [{
            market: getMarketsByCode(marketCode, selectedMatchdayEvent.markets),
            event: selectedMatchdayEvent
        }] : [];

        let marketUI;
        let marketName = getText(marketCode.name, store);
        let content;
        if (eventMarkets && eventMarkets.length > 0) {
            switch (marketCode) {
                case WIN_DRAW_WIN:
                    content = (
                        <WinDrawWin callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store} key={key}
                                    standardView={true}/>);
                    marketUI = (
                        <Accordion marketLabel={getText('MATCH_RESULT', this.props.store)} store={store} key={key}
                                   index={key} content={content}/>);
                    break;
                case UNDER_OVER:
                    content = (
                        <UnderOver callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store} key={key}
                                   standardView={true}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case BOTH_TEAMS_SCORE:
                    content = (<BothTeamsScore callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store}
                                               key={key} standardView={true}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case TOTAL_GOALS:
                    content = (<TotalGoals callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store}
                                           key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case HANDICAP:
                    content = (
                        <Handicap callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case CORRECT_SCORE:
                    content = (<CorrectScore callbacks={() => undefined} matchdayMarkets={eventMarkets} store={store}
                                             key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                default:
                    break;
            }
        }
        return marketUI;
    }

    render() {
        let selectedMatchdayEventId = this.state.selectedMatchdayEventId;
        let content;
        let fadeIn = this.fadeInContent ? style.fadeIn : '';
        let store = this.props.store;
        let storeData = store.getState();
        let selectedMatchday = this.state.events[this.state.selectedEventIndex];
        let selectedEvent = selectedMatchday.find(function (item) {
            return item.eventId == selectedMatchdayEventId;
        });
        content = ALL_MATCHDAY_MARKETS.map((mkt, index) => this._generateMarketUI(mkt, selectedEvent, index));
        if (selectedMatchday && isMatchdayNMB(storeData)) {
            this._closeMoreBetsScreen();
        }
        return (
            <div className={style.moreBetsUIContainer} ref={this.containerRef}>
                <div className={style.container}>
                    <div className={fadeIn}>
                        {content}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(MatchdayMoreBets);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/matchdayMoreBets.js